<template>
    <div v-loading="loading_submit"
         class="pos-payment row col-lg-12 m-0 p-0">
        <Keypress :key-code="113"
                  key-event="keyup"
                  @success="handleFn113"/>

        <div class="col-lg-4 col-md-6 bg-white m-0 p-0">
            <div class="h-60 bg-white"
                 style="overflow-y: auto">

                <div class="card card-body mb-2 pos-client-info">
                    <span>Cliente:</span>
                    <b class="mb-2">{{ customer.description }}</b>

                    <!-- sistema por puntos -->
                    <div v-if="enabledPointSystem" class="mt-3">
                        <p class="fs-point-system m-0 exchange-currency">
                            Puntos acumulados: <span>{{customer_accumulated_points}}</span>

                            <template v-if="total_exchange_points > 0">
                            - <b style="color:red">{{ total_exchange_points }}</b> = <b>{{ calculate_customer_accumulated_points }}</b>
                            </template>
                        </p>
                        <p class="fs-point-system text-success exchange-currency">
                            Puntos por la compra: <span>{{total_points_by_sale}}</span>
                        </p>
                    </div>
                    <!-- sistema por puntos -->
                </div>

                <template v-for="(item,index) in form.items">
                    <div :key="index"
                         class="row py-1 border-bottom m-0 p-0 bg-white">
                        <div class="col-2 p-r-0 m-l-2">
                            <p class="m-0">{{ item.quantity }}</p>

                        </div>
                        <div class="col-6 px-0">
                            <p class="m-0 m-b-0">{{ item.item.description }}</p>
                            <!-- <p class="m-b-0">Descripción del producto</p> -->
                            <!-- <p class="text-muted m-b-0"><small>Descuento 2%</small></p> -->
                        </div>
                        <div class="col-4 p-l-0">
                            <!-- <p class="font-weight-semibold m-b-0">{{currencyTypeActive.symbol}} 240.00</p> -->
                            <p class="m-0 text-right">
                                {{ currencyTypeActive.symbol }} {{ (item.total).toFixed(2) }}</p>
                        </div>

                        <!-- sistema por puntos -->
                        <template v-if="isAvailablePointSystem(item)">
                            <div class="col-2">
                            </div>
                            <div class="col-10 px-0">
                                <el-checkbox class="mt-2 mb-2" v-model="item.item.exchanged_for_points" @change="changeRowExchangePoints(item, index)"><b>{{ getExchangePointDescription(item) }}</b></el-checkbox>
                            </div>
                        </template>
                        <!-- sistema por puntos -->


                        <!-- restriccion venta productos -->
                        <template v-if="isRestrictedForSale(item.item)">
                            <div class="col-2"></div>
                            <div class="col-10 px-0">
                                <span class="text-danger mt-1 mb-2 d-block">Restringido para venta en CPE</span>
                            </div>
                        </template>

                    </div>
                </template>


            </div>
            <div class="h-40"
                 style="overflow-y: auto">
                <template v-if="form.total_plastic_bag_taxes > 0">
                    <div class="row m-0 p-0 bg-white h-17 d-flex align-items-center">
                        <div class="col-sm-6 py-1">
                            <p class="font-weight-semibold mb-0">SUBTOTAL</p>
                        </div>
                        <div class="col-sm-6 py-1 text-right">
                            <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }} {{
                                    form.total_taxed
                                                                 }}</p>
                        </div>
                    </div>
                    <div class="row m-0 p-0 bg-white h-17 d-flex align-items-center">
                        <div class="col-sm-6 py-1">
                            <p class="font-weight-semibold mb-0">IGV</p>
                        </div>
                        <div class="col-sm-6 py-1 text-right">
                            <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }}
                                                                 {{ form.total_igv }}</p>
                        </div>
                    </div>
                    <div class="row m-0 p-0 bg-white h-17 d-flex align-items-center" v-if="form.total_isc > 0">
                        <div class="col-sm-6 py-1">
                            <p class="font-weight-semibold mb-0">ISC</p>
                        </div>
                        <div class="col-sm-6 py-1 text-right">
                            <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }}
                                                                 {{ form.total_isc }}</p>
                        </div>
                    </div>
                    <div class="row m-0 p-0 bg-white h-17 d-flex align-items-center">
                        <div class="col-sm-6 py-1">
                            <p class="font-weight-semibold mb-0">ICBPER</p>
                        </div>
                        <div class="col-sm-6 py-1 text-right">
                            <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }}
                                                                 {{ form.total_plastic_bag_taxes }}</p>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="container card card-body pos-client-info mx-0 px-0">

                        <div class="row justify-content-center m-0">
                            <div class="col-sm-6">
                                <p class="mb-0">SUBTOTAL</p>
                            </div>
                            <div class="col-sm-6 text-right">
                                <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }} {{
                                        form.total_taxed }}</p>
                            </div>
                        </div>

                        <div class="row justify-content-center m-0">
                            <div class="col-sm-6">
                                <p class="mb-0">IGV</p>
                            </div>
                            <div class="col-sm-6 text-right">
                                <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }}
                                                                    {{ form.total_igv }}</p>
                            </div>
                        </div>

                    </div>
                    <div class="row m-0 p-0 bg-white d-flex align-items-center" v-if="form.total_isc > 0">
                        <div class="col-sm-6">
                            <p class="mb-0">ISC</p>
                        </div>
                        <div class="col-sm-6 text-right">
                            <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }}
                                                                {{ form.total_isc }}</p>
                        </div>
                    </div>

                    <div class="row m-0 p-0 bg-white h-17 d-flex align-items-center">
                        <div class="col-sm-6 py-1">
                            <p class="font-weight-semibold mb-0">DSCTO TOTALES</p>
                        </div>
                        <div class="col-sm-6 py-1 text-right">
                            <p class="font-weight-semibold mb-0">{{ currencyTypeActive.symbol }} {{
                                    totalDiscountOnlyVisual }}</p>
                        </div>
                    </div>

                </template>

                <!-- <div class="row m-0 p-0 bg-white">
                    <div class="col-sm-6 py-1">
                        <p class="font-weight-semibold mb-0">DESCUENTO</p>
                    </div>
                    <div class="col-sm-6 py-1 text-right">
                        <p class="font-weight-semibold mb-0">{{currencyTypeActive.symbol}} 4.00</p>
                    </div>
                </div> -->

                
                <div class="row mt-1 mb-1 justify-content-center m-0 text-secondary" style="padding: 0 10px;">
                    <div class="col-sm-6 p-0">
                        <p class="mb-0">
                            Redondeo
                            <el-tooltip content="El redondeo debe ser un valor entre -0.99 y 0.99" effect="dark" placement="top-start">
                                <i class="fa fa-info-circle"></i>
                            </el-tooltip>
                            :
                        </p>
                    </div>
                    <div class="col-sm-6 p-0 text-right">
                        <div style="display: flex; column-gap: 3px; align-items: center;">
                            <div>
                                {{ currencyTypeActive.symbol }}
                            </div>

                            <el-input-number v-model="form.rounding" 
                                                        :min="-0.99"
                                                        :max="0.99"
                                                        :step="0.01"
                                                        class="input-custom"
                                                        controls-position="right"
                                                        @change="addRounding"
                                                        @blur="checkRounding"></el-input-number>
                        </div>
                    </div>
                </div>

                <div class="row mt-0 mb-3 justify-content-center m-0 text-secondary card-body pos-client-info">
                    <div class="col-sm-6 p-0">
                        <p class="font-weight-semibold text-sm text-secondary mb-0">TOTAL</p>
                    </div>
                    <div class="col-sm-6 p-0 text-right">
                        <p class="font-weight-semibold text-sm text-secondary mb-0">{{ currencyTypeActive.symbol }} {{form.total}}</p>
                    </div>
                </div>
                <div class="row m-0 p-0 d-flex align-items-center">
                    <div class="col-lg-12">
                        <button :disabled="button_payment && payment_method_type_id != '09' || loading_submit"
                                class="btn py-3 btn-block btn-primary"
                                @click="clickPayment">PAGAR <i class="fas fa-wallet ml-2"></i>
                        </button>
                    </div>
                    <div class="col-lg-12 center">
                        <button class="btn btn-link text-danger"
                                @click="clickCancel">Cancelar Compra
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-8 col-md-6 px-4 pt-3 hyo">
            <div class="row d-flex justify-content-center pt-2">

                <div class="col-lg-8">
                <div class="card card-body">

                <div class="d-flex justify-content-between">

                    <div>
                        <button class="btn btn-sm btn-block btn-warning"
                                @click="back"><i class="fas fa-angle-left"></i> Regresar
                        </button>
                    </div>

                    <div>
                        <el-select v-model="form.series_id"
                                class="c-width">
                            <el-option v-for="option in series"
                                    :key="option.id"
                                    :label="option.number"
                                    :value="option.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div>
                        <el-radio-group v-model="form.document_type_id"
                                        size="small"
                                        @change="filterSeries">
                            <el-radio-button label="01">FACTURA</el-radio-button>
                            <el-radio-button label="03">BOLETA</el-radio-button>
                            <el-radio-button label="80">N. VENTA</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                </div>
                </div>



                <div class="col-lg-8 mt-2">
                    <div class="card card-default">

                        <div class="card-body text-center">
                            <p class="my-0"><small>Monto a cobrar</small></p>
                            <!-- <template v-if="enabled_discount && form.total_payable_amount">
                                <h1 class="mb-2 mt-0">{{ currencyTypeActive.symbol }} {{ form.total_payable_amount }}</h1>
                            </template>
                            <template v-else> -->
                                <h1 class="mb-2 mt-0">{{ currencyTypeActive.symbol }} {{ form.total }}</h1>
                            <!-- </template> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card card-default">

                        <div class="card-body text-center">

                            <div class="row col-lg-12">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="control-label">Ingrese monto</label>
                                        <el-input ref="enter_amount"
                                                  v-model="enter_amount"
                                                  @input="enterAmount()"
                                                  @keyup.enter.native="keyupEnterAmount()">
                                            <template slot="prepend">{{ currencyTypeActive.symbol }}</template>
                                        </el-input>

                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div :class="{'has-danger': difference < 0}"
                                         class="form-group">
                                        <label class="control-label"
                                               v-text="(difference <0) ? 'Faltante' :'Vuelto'"></label>
                                        <!-- <el-input v-model="difference" :disabled="true">
                                            <template slot="prepend">{{currencyTypeActive.symbol}}</template>
                                        </el-input> -->
                                        <h4 class="control-label font-weight-semibold m-0 text-center m-b-0">
                                            {{ currencyTypeActive.symbol }} {{ difference }}</h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="col-lg-8">
                    <div class="card card-default">

                        <div class="card-body text-center">

                            <div class="row col-lg-12" v-if="form.total > 0 && canApplyGlobalDiscount">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <h2>
                                            <el-switch v-model="enabled_discount"
                                                       active-text="Aplicar descuento"
                                                       class="control-label font-weight-semibold m-0 text-center m-b-0"
                                                       @change="changeEnabledDiscount"></el-switch>
                                        </h2>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="control-label">

                                            <el-checkbox v-model="is_discount_amount"
                                                            class="ml-1 mr-1"
                                                            @change="changeTypeDiscount"></el-checkbox>

                                            <template>{{ (is_discount_amount) ? 'Monto' : 'Porcentaje'}} descuento</template>

                                            <el-tooltip class="item"
                                                        v-if="global_discount_type && global_discount_type.description"
                                                        :content="global_discount_type.description"
                                                        effect="dark"
                                                        placement="top">
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>

                                        </label>
                                        <el-input v-model="discount_amount"
                                                  :disabled="!enabled_discount"
                                                  @change="inputDiscountAmount()"
                                                  >

                                            <template slot="prepend" v-if="is_discount_amount">{{ currencyTypeActive.symbol }}</template>
                                            <template slot="append" v-else>%</template>

                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <div v-if="businessTurns.active"
                                 class="row col-md-12 col-lg-12">
                                <div class="col-md-6 col-lg-6"></div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="control-label">N° Placa</label>
                                        <el-input v-model="form.plate_number"
                                                  type="textarea"></el-input>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <!-- propinas -->
                <div class="col-lg-8" v-if="enabledTipsPos">

                    <div class="card card-default">
                        <div class="card-body">

                            <div class="row col-lg-12 mb-2 mt-1">

                                <div class="col-lg-12">
                                    <h5><strong>Registrar propina</strong>
                                        <el-tooltip class="item"
                                                    content="Para registrar la propina debe ingresar los datos del empleado y el monto debe ser mayor a 0"
                                                    effect="dark"
                                                    placement="top">
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                    </h5>
                                </div>

                                <div class="col-lg-8">
                                    <div class="form-group">
                                        <label class="control-label">Empleado</label>
                                        <el-input v-model="form.worker_full_name_tips"></el-input>
                                    </div>
                                </div>

                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label class="control-label">Monto</label>
                                        <el-input-number v-model="form.total_tips" :min="0" controls-position="right"></el-input-number>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- propinas -->

                <div class="col-lg-8">
                    <div class="card card-default">
                        <div class="card-body">
                            <!-- <p class="text-center">Método de Pago</p> -->
                            <div class="input-group mb-3">
                                <div class="col-lg-12 m-bottom">
                                    <div class="row">

                                        <div class="col-lg-6">
                                            <h5><strong>Pagos agregados </strong></h5>
                                        </div>
                                        <div class="col-lg-1">
                                        </div>
                                        <div class="col-lg-5">
                                            <button class="btn btn-sm btn-block btn-primary"
                                                    @click="clickAddPayment()"><i class="fas fa-plus"></i> Agregar
                                            </button>

                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12 m-bottom">
                                    <div class="row">
                                        <template v-for="(pay,index) in form.payments">
                                            <div :key="pay.id"
                                                 class="col-lg-1">
                                                <label>{{ index + 1 }}.-</label>
                                            </div>
                                            <div :key="pay.id"
                                                 class="col-lg-6">
                                                <label>{{ getDescriptionPaymentMethodType(pay.payment_method_type_id) }}</label>
                                            </div>
                                            <div :key="pay.id"
                                                 class="col-lg-5">
                                                <label><strong>{{ currencyTypeActive.symbol }}
                                                               {{ pay.payment }}</strong> </label>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-12 m-bottom">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <label class="control-label" >Método de Pago</label>

                                            <el-select v-model="form_payment.payment_method_type_id" @change="changePaymentMethodType">
                                                    <el-option v-for="option in payment_method_types" :key="option.id" :value="option.id" :label="option.description"></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 m-bottom" v-if="has_card">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <label class="control-label" >Tarjeta
                                            <a class="text-info" @click.prevent="showDialogNewCardBrand = true" href="#">[+ Nueva]</a>
                                            </label>
                                            <el-select v-model="form_payment.card_brand_id">
                                                    <el-option v-for="option in cards_brand" :key="option.id" :value="option.id" :label="option.description"></el-option>
                                            </el-select>

                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-12 m-bottom" >
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <label class="control-label"  >Referencia</label>
                                            <el-input v-model="form_payment.reference" >
                                            </el-input>
                                        </div>
                                    </div>
                                </div>-->
                                <div v-if="form_payment.payment_method_type_id=='01'"
                                     class="col-lg-12">
                                    <div class="row">
                                        <div class="col-lg-3">
                                            <button class="btn btn-block btn-secondary"
                                                    @click="setAmountCash(10)">{{ currencyTypeActive.symbol }}10
                                            </button>
                                        </div>
                                        <div class="col-lg-3">
                                            <button class="btn btn-block btn-secondary"
                                                    @click="setAmountCash(20)">{{ currencyTypeActive.symbol }}20
                                            </button>
                                        </div>
                                        <div class="col-lg-3">
                                            <button class="btn btn-block btn-secondary"
                                                    @click="setAmountCash(50)">{{ currencyTypeActive.symbol }}50
                                            </button>
                                        </div>
                                        <div class="col-lg-3">
                                            <button class="btn btn-block btn-secondary"
                                                    @click="setAmountCash(100)">{{ currencyTypeActive.symbol }}100
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card card-default">
                        <div class="card-body">
                            <div class="row col-lg-12">

                                <div class="col-md-12 col-lg-12 mb-1" v-if="configuration.enabled_sales_agents">
                                    <search-agent @changeAgent="changeAgent"></search-agent>
                                </div>

                                <div class="col-md-12 col-lg-12">
                                    <div class="form-group">
                                        <label class="control-label">Datos de referencia</label>
                                        <el-input v-model="form.reference_data"
                                                  type="textarea"></el-input>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <options-form
            :recordId="documentNewId"
            :resource="resource_options"
            :showDialog.sync="showDialogOptions"
            :statusDocument="statusDocument"
            :fromPos="true"
        ></options-form>

        <multiple-payment-form
            :payments="payments"
            :showDialog.sync="showDialogMultiplePayment"
            :total="form.total"
            @add="addRow"
            @setPaymentMethod="setPaymentMethod"

        ></multiple-payment-form>

        <!-- <sale-notes-options :showDialog.sync="showDialogSaleNote"
                          :recordId="saleNotesNewId"
                          :showClose="true"></sale-notes-options>  -->

        <card-brands-form :external="true"
                          :recordId="null"
                          :showDialog.sync="showDialogNewCardBrand"></card-brands-form>

        <discount-permission-form
                    :showDialog.sync="showDialogDiscountPermission"
                    :totalDiscountPercentage ="totalDiscountPercentage"
                    :sellers-discount-limit="configuration.sellers_discount_limit"
                    @tokenValidated="tokenValidated"></discount-permission-form>
    </div>
</template>
<style>
.c-width {
    margin-right: 0 !important;
    padding: 0 !important;
    width: 80px !important;
}
.card {
    margin-bottom: 2px;
}
.card-body {
    padding: 10px;
}
</style>

<script>
import Keypress from 'vue-keypress'

import CardBrandsForm from '../../card_brands/form.vue'
import SaleNotesOptions from '../../sale_notes/partials/options.vue'
import OptionsForm from './options.vue'
import MultiplePaymentForm from './multiple_payment.vue'
import {pointSystemFunctions} from '@mixins/functions'
import {calculateRowItem} from "@helpers/functions"
import DiscountPermissionForm from './discount_permission.vue'
import SearchAgent from '@components/SearchAgent.vue'
import _ from 'lodash'


export default {
    components: {OptionsForm, CardBrandsForm, SaleNotesOptions, MultiplePaymentForm, Keypress, DiscountPermissionForm, SearchAgent},
    mixins: [pointSystemFunctions],

    props: [
        'form',
        'customer',
        'currencyTypeActive',
        'exchangeRateSale',
        'is_payment',
        'soapCompany',
        'businessTurns',
        'isPrint',
        'globalDiscountTypeId',
        'enabledTipsPos',
        'hidePdfViewDocuments',
        'enabledPointSystem',
        'affectationIgvTypes',
        'percentageIgv',
        'configuration',
        'typeUser',
    ],

    data() {
        return {
            enabled_discount: false,
            discount_amount: 0,
            loading_submit: false,
            showDialogOptions: false,
            showDialogMultiplePayment: false,
            showDialogSaleNote: false,
            showDialogNewCardBrand: false,
            documentNewId: null,
            saleNotesNewId: null,
            resource_options: null,
            has_card: false,
            resource: 'pos',
            resource_documents: 'documents',
            resource_payments: 'document_payments',
            amount: 0,
            enter_amount: 0,
            difference: 0,
            button_payment: false,
            input_item: '',
            form_payment: {},
            series: [],
            all_series: [],
            cards_brand: [],
            cancel: false,
            form_cash_document: {},
            statusDocument: {},
            payment_method_types: [],
            payments: [],
            locked_submit: false,
            global_discount_types: [],
            enabled_discount_global: false,
            global_discount_type: {},
            error_global_discount: false,
            is_discount_amount: false,
            payment_method_type_id: null,
            showDialogDiscountPermission: false,
            totalDiscountPercentage: 0,
            total_discount_no_base: 0,
            monto_pagar_sin_dcto: 0,
            total_original: 0,
        }
    },
    async created() {

        await this.initLStoPayment()
        this.getTables()
        this.initFormPayment()
        this.inputAmount()
        this.form.payments = []
        this.$eventHub.$on('reloadDataCardBrands', (card_brand_id) => {
            this.reloadDataCardBrands(card_brand_id)
        })

        this.$eventHub.$on('localSPayments', (payments) => {
            this.payments = payments

        })

        await this.setInitialAmount()

        await this.getFormPosLocalStorage()
        // console.log(this.form.payments, this.payments)
        // console.log(this.isPrint);
        if (!qz.websocket.isActive() && this.isPrint) {
            startConnection();
        }

        if(this.enabledPointSystem)
        {
            await this.setCustomerAccumulatedPoints(this.form.customer_id, true)
            this.setTotalExchangePoints()
            this.checkUsedPointsByItem()
        }

        this.setTotalPointsBySale(this.configuration)

    },
    mounted() {
        // console.log(this.currencyTypeActive)
    },
    computed: {
        isGlobalDiscountBase: function () {
            return (this.globalDiscountTypeId === '02')
        },
        canApplyGlobalDiscount() {
            return this.enabled_discount_global
                && !(this.configuration && this.configuration.activate_tip_charge)
        },
        isInvoiceDocument()
        {
            return ['01', '03'].includes(this.form.document_type_id)
        },
        applyRestrictSaleItemsCpe()
        {
            if (this.configuration) return this.configuration.restrict_sale_items_cpe

            return false
        },

        totalDiscountOnlyVisual() {
            const discount_per_items = this.form.items.reduce((total, item) => {
                let discounts = item.discounts

                // puede llegar como objeto indexado {0:{...},1:{...}} desde la BD
                if (discounts && !Array.isArray(discounts) && typeof discounts === 'object') {
                    discounts = Object.values(discounts)
                }

                const sumDiscounts = (discounts && Array.isArray(discounts))
                    ? discounts.reduce((sum, discount) => sum + (Number(discount.amount) || 0), 0)
                    : 0

                return total + sumDiscounts
            }, 0)

            let global_discount = 0
            let aux_global_discount = Number(this.discount_amount) || 0

            if (!this.is_discount_amount) {
                global_discount = _.round(this.total_original * (aux_global_discount / 100), 2)
            } else {
                global_discount = aux_global_discount
            }

            const total_discounts = _.round(discount_per_items + global_discount, 2)

            this.form.dcto_totales_input = total_discounts

            return total_discounts
        },
    },
    watch: {
        'form.rounding': function () {
            this.reCalculateTotal()
            this.difference = _.round(this.enter_amount - this.form.total, 2)
        }
    },
    methods:
    {
        addRounding() {
            // let rounding = parseFloat(this.form.rounding) || 0
            // this.form.total = (parseFloat(this.form.total) + rounding).toFixed(2)
        },

        checkRounding() {
            if (this.form.rounding == '') {
                this.form.rounding = 0
            }
        },

        isRestrictedForSale(item)
        {
            return this.applyRestrictSaleItemsCpe && this.isInvoiceDocument && (item != undefined && item.restrict_sale_cpe)
        },
        changeAgent(agent_id)
        {
            this.form.agent_id = agent_id
        },
        checkUsedPointsByItem()
        {
            this.form.items.forEach(row => {
                this.recalculateUsedPointsForExchange(row)
            })
        },
        isAvailablePointSystem(row)
        {
            return (this.enabledPointSystem && this.customer_accumulated_points > 0 && row.item.exchange_points)
        },
        changeRowExchangePoints(row, index)
        {
            row.item.used_points_for_exchange = row.item.exchanged_for_points ? this.getUsedPoints(row) : null
            this.setTotalExchangePoints()
            this.changeRowFreeAffectationIgv(row, index)
        },
        async changeRowFreeAffectationIgv(row, index)
        {
            this.form.items[index].affectation_igv_type_id = (row.item.exchanged_for_points) ? '15' : this.form.items[index].item.original_affectation_igv_type_id
            this.form.items[index].affectation_igv_type = await _.find(this.affectationIgvTypes, {id: this.form.items[index].affectation_igv_type_id})

            let new_row = await calculateRowItem(row, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentageIgv)
            new_row['unit_type_id'] = row.unit_type_id

            this.form.items[index] = new_row
            await this.reCalculateTotal()
        },
        handleFn113() {
            const code = this.form.document_type_id
            if (code == '01') {
                this.form.document_type_id = '03'
            } else if (code == '03') {
                this.form.document_type_id = '80'
            } else if (code == '80') {
                this.form.document_type_id = '01'
            }

            this.filterSeries()
        },
        keyupEnterAmount() {

            if (this.button_payment) {
                return this.$message.warning("El monto a pagar es menor al total")
            }

            if (this.locked_submit) return;

            this.clickPayment()

        },
        async setInitialAmount() {
            this.enter_amount = this.form.total
            // this.form.payments = this.payments
            // this.$eventHub.$emit('eventSetFormPosLocalStorage', this.form)
            await this.$refs.enter_amount.$el.getElementsByTagName('input')[0].focus()
            await this.$refs.enter_amount.$el.getElementsByTagName('input')[0].select()
            // console.log(this.$refs.enter_amount.$el.getElementsByTagName('input')[0])
        },
        changeEnabledDiscount() {

            if (!this.enabled_discount) {

                this.discount_amount = 0
                this.deleteDiscountGlobal()
                this.reCalculateTotal()

            }

        },
        changeTypeDiscount() {
            this.inputDiscountAmount()
        },
        inputDiscountAmount() {

            if (this.enabled_discount) {
                //this.total_original = this.form.total

                if (this.discount_amount && !isNaN(this.discount_amount) && parseFloat(this.discount_amount) > 0) {

                    if(this.is_discount_amount)
                    {
                        if (this.discount_amount >= this.form.total)
                            return this.$message.error("El monto de descuento debe ser menor al total de venta")
                    }
                    
                    this.deleteDiscountGlobal()
                    this.reCalculateTotal()

                } else {

                    // this.discount_amount = 0
                    this.deleteDiscountGlobal()
                    this.reCalculateTotal()

                }

                // console.log(this.discount_amount)
            }
        },
        isExonerated() {

            let not_exonerated = this.form.items.find((item) => {
                return item.affectation_igv_type_id != '20'
            })

            return (not_exonerated) ? false : true
        },
        setConfigGlobalDiscountType()
        {
            this.global_discount_type = _.find(this.global_discount_types, { id : this.globalDiscountTypeId})
        },
        setGlobalDiscount(factor, amount, base, type_discount = null)
        {

            const discountTypeId = type_discount || this.globalDiscountTypeId
            const discountType = _.find(this.global_discount_types, {
                id: discountTypeId
            })

            this.form.discounts.push({
                discount_type_id: discountTypeId,
                description: discountType ? discountType.description : '',
                factor: factor,
                amount: _.round(amount, 2),
                base: base,
                is_amount: this.is_discount_amount
            })
        },
        async discountGlobal() {
            this.deleteDiscountGlobal()
            const inputDiscount = Number(this.discount_amount) || 0
            const taxedBase = Number(this.form.total_taxed_without_rounding) || 0

            const nonTaxedBase = _.round(
                this.form.items.reduce((sum, row) => {
                    const affectationId = String(row.affectation_igv_type_id)

                    if (!['20', '30'].includes(affectationId)) return sum

                    const value = row.total_value_without_rounding != null
                        ? Number(row.total_value_without_rounding)
                        : Number(row.total_value)

                    return sum + (Number.isFinite(value) ? value : 0)
                }, 0),
                2
            )

            if (taxedBase > 0 && nonTaxedBase > 0 && inputDiscount > 0) {
                this.setMixedGlobalDiscount(inputDiscount, taxedBase, nonTaxedBase)
                this.difference = _.round(this.enter_amount - this.form.total, 2)
                return
            }

        //this.form.discounts = []
            const hasTaxed = taxedBase > 0
            const hasNonTaxed = nonTaxedBase > 0

            if (!hasTaxed && !hasNonTaxed && inputDiscount > 0) {
                this.$message.error(
                    'No existen operaciones gravadas, exoneradas o inafectas onerosas para distribuir el descuento'
                )
                return
            }

            if (hasTaxed && hasNonTaxed && inputDiscount > 0) {
                this.setMixedGlobalDiscount(inputDiscount, taxedBase, nonTaxedBase)
                this.difference = _.round(this.enter_amount - this.form.total, 2)
                return
            }
            // let percentage_igv = 18
            // let amount = parseFloat(this.discount_amount)
            // const input_global_discount = parseFloat(this.discount_amount) //input se usa para monto y porcentaje
            // let base = (this.globalDiscountTypeId === '02') ? parseFloat(this.form.total_taxed) : parseFloat(this.form.total)
            // let factor = _.round(amount / base, 5)

            let input_global_discount_ = parseFloat(this.discount_amount)
            if (!hasTaxed && hasNonTaxed && inputDiscount > 0) {
                 const base = parseFloat(this.form.total)
            let amount = 0
            let factor = 0

            if (this.is_discount_amount) {
                amount = input_global_discount_
                factor = _.round(amount / base, 5)
            } else {
                factor = _.round(input_global_discount_ / 100, 5)
                amount = factor * base
            }

            const new_total = _.round(base - amount, 2)

            if (new_total <= 0) {
                this.$message.error('El descuento debe ser menor al total de la venta')
                return
            }

            this.form.total_discount = _.round(this.getItemsTotalDiscount() + amount, 5)
            this.form.subtotal = base
            this.form.total = new_total

            // Solo operaciones exoneradas/inafectas: no hay base imponible de IGV que
            // afectar, por eso siempre se registra como tipo 03 (no afecta la BI).
            this.setGlobalDiscount(factor, _.round(amount, 2), base.toFixed(2), '03')
            } else {


                const percentage_igv = this.percentageIgv * 100
                let input_global_discount = Number(this.discount_amount) || 0

                const total_percentage_products = this.form.items.reduce((total, row) => {
                    const tip = Number(row.item && row.item.tip_percentage)
                    return total + (Number.isFinite(tip) ? tip : 0)
                }, 0)

                if (this.is_discount_amount && this.isGlobalDiscountBase) {
                    const divisor =
                        1 + this.percentageIgv + (total_percentage_products / 100)

                    input_global_discount = _.round(
                        input_global_discount / divisor,
                        5
                    )
                }

                if (input_global_discount > 0) {
                    const base = this.isGlobalDiscountBase
                        ? Number(this.form.total_taxed_without_rounding)
                        : Number(this.form.total)

                    const factor = this.is_discount_amount
                        ? _.round(input_global_discount / base, 5)
                        : _.round(input_global_discount / 100, 5)

                    const amount = this.is_discount_amount
                        ? input_global_discount
                        : factor * base

                    const globalDiscountAmount = _.round(amount, 5)

                    // --- calcular sin mutar el form ---
                    let next = null

                    if (this.isGlobalDiscountBase) {
                        const total_taxed = _.round(base - globalDiscountAmount, 2)
                        const total_igv   = _.round(total_taxed * (percentage_igv / 100), 2)
                        const charge_46   = _.round(total_taxed * (total_percentage_products / 100), 2)
                        const total_taxes = _.round(
                            total_igv + this.form.total_isc + this.form.total_plastic_bag_taxes, 2
                        )
                        const total = _.round(
                            total_taxed + total_taxes + charge_46 + Number(this.form.rounding || 0), 2
                        )

                        next = { total_taxed, total_igv, total_taxes, total }
                    } else {
                        next = { total: _.round(this.form.total - globalDiscountAmount, 2) }
                    }

                    if (next.total <= 0) {
                        this.$message.error('El total debe ser mayor a 0, verifique el monto de descuento ingresado')
                        return
                    }

                    // --- commit ---
                    this.form.total_discount = _.round(
                        this.getItemsTotalDiscount() + globalDiscountAmount, 5
                    )

                    if (this.isGlobalDiscountBase) {
                        this.form.total_taxed = next.total_taxed
                        this.form.total_value = next.total_taxed
                        this.form.total_igv   = next.total_igv
                        this.form.total_taxes = next.total_taxes
                        this.form.total       = next.total
                        this.form.subtotal    = next.total
                    } else {
                        this.form.total = next.total
                    }

                    this.setGlobalDiscount(factor, _.round(globalDiscountAmount, 2), base.toFixed(2))
                }


                    /*this.setGlobalDiscount(factor, amount, base)
                }*/


            }

            
            


            this.difference = _.round(this.enter_amount - this.form.total, 2)

            // this.difference = this.enter_amount - this.form.total_payable_amount
            // console.log(this.form.discounts)
        },
        reCalculateTotal() {

            let total_discount = 0
            let total_charge = 0
            let total_exportation = 0
            let total_taxed = 0
            let total_exonerated = 0
            let total_unaffected = 0
            let total_free = 0
            let total_igv = 0
            let total_value = 0
            let total = 0
            let total_plastic_bag_taxes = 0
            let total_base_isc = 0
            let total_isc = 0
            let total_igv_free = 0
            this.total_discount_no_base = 0
            

            this.monto_pagar_sin_dcto = this.form.items.reduce(
                (sum, item) => sum + (Number(item.total_original) || Number(item.total) || 0),
                0
            )


            this.form.items.forEach((row) => {
                total_discount += parseFloat(row.total_discount)
                total_charge += parseFloat(row.total_charge)

                if (row.affectation_igv_type_id === '10') {
                    total_taxed += (row.total_value_without_rounding) ? parseFloat(row.total_value_without_rounding) : parseFloat(row.total_value)
                }

                if (row.affectation_igv_type_id === '20') {
                    total_exonerated += (row.total_value_without_rounding) ? parseFloat(row.total_value_without_rounding) : parseFloat(row.total_value)
                }

                if (['30', '31', '32', '33', '34', '35', '36'].includes(row.affectation_igv_type_id)) {
                    total_unaffected += parseFloat(row.total_value)
                }

                if (row.affectation_igv_type_id === '40') {
                    total_exportation += parseFloat(row.total_value)
                }

                if (['10', '20', '30', '31', '32', '33', '34', '35', '36', '40'].indexOf(row.affectation_igv_type_id) < 0) {
                    total_free += parseFloat(row.total_value)
                }

                // if (['10', '20', '30', '40'].indexOf(row.affectation_igv_type_id) > -1) {
                if (['10', '20', '21', '30', '31', '32', '33', '34', '35', '36', '40'].indexOf(row.affectation_igv_type_id) > -1)
                {
                    total_igv += (row.total_igv_without_rounding) ? parseFloat(row.total_igv_without_rounding) : parseFloat(row.total_igv)
                    total += (row.total_without_rounding) ? parseFloat(row.total_without_rounding) : parseFloat(row.total)
                }

                if(!['21', '37'].includes(row.affectation_igv_type_id))
                {
                    total_value += (row.total_value_without_rounding) ? parseFloat(row.total_value_without_rounding) : parseFloat(row.total_value)
                }

                total_plastic_bag_taxes += parseFloat(row.total_plastic_bag_taxes)


                if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {

                    let unit_value = row.total_value / row.quantity
                    let total_value_partial = unit_value * row.quantity
                    row.total_taxes = row.total_value - total_value_partial + parseFloat(row.total_plastic_bag_taxes) //sumar icbper al total tributos

                    row.total_igv = total_value_partial * (row.percentage_igv / 100)
                    row.total_base_igv = total_value_partial
                    total_value -= row.total_value

                    total_igv_free += row.total_igv
                    total += parseFloat(row.total) //se agrega suma al total para considerar el icbper

                }
                this.total_discount_no_base += this.sumDiscountsNoBaseByItem(row)
                // isc
                total_isc += parseFloat(row.total_isc)
                total_base_isc += parseFloat(row.total_base_isc)

            });

            // isc
            this.form.total_base_isc = _.round(total_base_isc, 2)
            this.form.total_isc = _.round(total_isc, 2)

            this.form.total_igv_free = _.round(total_igv_free, 2)
this.form.total_discount = _.round(total_discount, 2)
            this.form.total_exportation = _.round(total_exportation, 2)
            this.form.total_taxed = _.round(total_taxed, 2)
            this.form.total_exonerated = _.round(total_exonerated, 2)
            this.form.total_unaffected = _.round(total_unaffected, 2)
            this.form.total_free = _.round(total_free, 2)
            this.form.total_igv = _.round(total_igv, 2)
            this.form.total_value = _.round(total_value, 2)
            // this.form.total_taxes = _.round(total_igv, 2)
            this.form.total_taxed = _.round(total_taxed, 2)
            //impuestos (isc + igv + icbper)
            this.form.total_taxes = _.round(total_igv + total_isc + total_plastic_bag_taxes, 2);
            // this.form.total_taxes = _.round(total_igv + total_isc, 2);
            this.form.total_taxed_without_rounding = _.round(total_taxed, 5)
            this.form.total_plastic_bag_taxes = _.round(total_plastic_bag_taxes, 2)

            // this.form.total = _.round(total, 2)
            // this.form.subtotal = this.form.total

            this.form.subtotal = _.round(total, 2)
            this.form.total =  _.round(total - this.total_discount_no_base + Number(this.form.rounding || 0), 2)

            //this.monto_pagar_sin_dcto = this.form.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total, 0)
            // this.total_original = this.form.total
            // this.form.total = _.round(total + this.form.total_plastic_bag_taxes, 2)
            // this.form.subtotal = _.round(total + this.form.total_plastic_bag_taxes, 2)
            this.total_original = this.form.total
            if (this.canApplyGlobalDiscount && this.enabled_discount) {
                this.discountGlobal()
            } else {
                this.deleteDiscountGlobal()
                this.difference = _.round(this.enter_amount - this.form.total, 2)
            }

            this.setTotalPointsBySale(this.configuration)

        },
        deleteDiscountGlobal() {

            const globalIds = ['02', '03']

            this.form.discounts = (this.form.discounts || []).filter(discount =>
                !globalIds.includes(
                    this.normalizeDiscountTypeId(discount.discount_type_id)
                )
            )

            this.form.total_discount = this.getItemsTotalDiscount()

        },
        back() {
            this.form.payments = []
            this.$emit('update:is_payment', false)
        },
        async initLStoPayment() {

            this.amount = await this.getLocalStoragePayment('amount', 0)
            this.enter_amount = await this.getLocalStoragePayment('enter_amount', 0)
            this.difference = await this.getLocalStoragePayment('difference', 0)
        },
        getFormPosLocalStorage() {

            let form_pos = localStorage.getItem('form_pos');
            form_pos = JSON.parse(form_pos)
            if (form_pos) {
                this.form.payments = form_pos.payments
            }

        },
        clickAddPayment() {
            this.showDialogMultiplePayment = true
        },
        reloadDataCardBrands(card_brand_id) {
            this.$http.get(`/${this.resource}/table/card_brands`).then((response) => {
                this.cards_brand = response.data
                this.form_payment.card_brand_id = card_brand_id
                this.changePaymentMethodType()
            })
        },
        getDescriptionPaymentMethodType(id) {
            let payment_method_type = _.find(this.payment_method_types, {'id': id})
            return (payment_method_type) ? payment_method_type.description : ''

        },
        changePaymentMethodType() {
            let payment_method_type = _.find(this.payment_method_types, {'id': this.form_payment.payment_method_type_id})
            this.has_card = payment_method_type.has_card
            this.form_payment.card_brand_id = (payment_method_type.has_card) ? this.form_payment.card_brand_id : null
        },
        addRow(payments) {

            this.form.payments = payments
            let acum_payment = 0

            this.form.payments.forEach((item) => {
                acum_payment += parseFloat(item.payment)
            })

            // this.amount = acum_payment
            this.setAmount(acum_payment.toFixed(2))

            // console.log(this.form.payments)
        },
        setPaymentMethod(id){
            this.payment_method_type_id = id;
        },
        setAmount(amount) {
            // this.amount = parseFloat(this.amount) + parseFloat(amount)
            this.amount = parseFloat(amount) //+ parseFloat(amount)
            this.enter_amount = parseFloat(amount) //+ parseFloat(amount)
            this.inputAmount()
        },
        setAmountCash(amount) {
            let row = _.last(this.payments, {'payment_method_type_id': '01'})
            row.payment = parseFloat(row.payment) + parseFloat(amount)
            // console.log(row.payment)

            this.form.payments = this.payments
            let acum_payment = 0

            this.form.payments.forEach((item) => {
                acum_payment += parseFloat(item.payment)
            })

            this.setAmount(acum_payment)

        },
        async enterAmount() {

            const current_total_amount = parseFloat(this.enter_amount)
            const payment_count = this.payments.length
            let payment = 0
            let amount = _.round(current_total_amount / payment_count, 2)
            this.payments.forEach((row, index) => {
                payment += amount
                if (index === payment_count - 1) {
                    amount = _.round(current_total_amount - (payment - amount), 2)
                }
                row.payment = amount
            })
            this.amount = current_total_amount
            this.difference = this.amount - this.form.total
            if (isNaN(this.difference)) {
                this.button_payment = true
                this.difference = "-"
            } else if (this.difference >= 0) {
                this.button_payment = false
                this.difference = this.amount - this.form.total
            } else {
                this.button_payment = true
            }
            this.difference = _.round(this.difference, 2)

            this.$eventHub.$emit('eventSetFormPosLocalStorage', this.form)

            await this.lStoPayment()




            // let r_item = await _.last(this.payments, {'payment_method_type_id': '01'})
            // r_item.payment = await parseFloat(this.enter_amount)
            // // console.log(r_item.payment)

            // let ind = this.form.payments.length - 1
            // this.form.payments[ind].payment = parseFloat(this.enter_amount)
            // // this.setAmount(item.payment)

            // let acum_payment = 0

            // await this.form.payments.forEach((item) => {
            //     acum_payment += parseFloat(item.payment)
            // })
            // // console.log(this.form.payments)

            // // this.amount = item.payment
            // this.amount = acum_payment
            // // this.amount = this.enter_amount
            // // console.log(this.amount)
            // this.difference = this.amount - this.form.total

            // if (isNaN(this.difference)) {
            //     this.button_payment = true
            //     this.difference = "-"
            // } else if (this.difference >= 0) {
            //     this.button_payment = false
            //     this.difference = this.amount - this.form.total
            // } else {
            //     this.button_payment = true
            // }
            // this.difference = _.round(this.difference, 2)

            // this.$eventHub.$emit('eventSetFormPosLocalStorage', this.form)

            // await this.lStoPayment()

        },
        getLocalStoragePayment(key, re_default = null) {

            let ls_obj = localStorage.getItem(key);
            ls_obj = JSON.parse(ls_obj)

            if (ls_obj) {
                return ls_obj
            }

            return re_default
        },
        setLocalStoragePayment(key, obj) {
            localStorage.setItem(key, JSON.stringify(obj));
        },
        inputAmount() {

            this.difference = this.amount - this.form.total
            if(this.payment_method_type_id == '09') {
                this.button_payment = false
            }
            else if (isNaN(this.difference)) {
                this.button_payment = true
                this.difference = "-"
            } else if (this.difference >= 0) {
                this.button_payment = false
                this.difference = this.amount - this.form.total
            } else {
                this.button_payment = true
            }
            this.difference = _.round(this.difference, 2)
            // this.form_payment.payment = this.amount

            this.$eventHub.$emit('eventSetFormPosLocalStorage', this.form)
            this.lStoPayment()

        },
        lStoPayment() {

            this.setLocalStoragePayment('enter_amount', this.enter_amount)
            this.setLocalStoragePayment('amount', this.amount)
            // console.log(this.amount)
            this.setLocalStoragePayment('difference', this.difference)

        },
        initFormPayment() {

            this.difference = -this.form.total

            this.form_payment = {
                id: null,
                date_of_payment: moment().format('YYYY-MM-DD'),
                payment_method_type_id: '01',
                reference: null,
                card_brand_id: null,
                document_id: null,
                sale_note_id: null,
                payment: this.form.total,
            }

            this.form_cash_document = {
                document_id: null,
                sale_note_id: null,

                cash_id: null
            }

            this.is_discount_amount = true

        },

        filterSeries() {
            this.form.series_id = null
            this.series = _.filter(this.all_series, {'document_type_id': this.form.document_type_id});
            this.form.series_id = (this.series.length > 0) ? this.series[0].id : null

            if (!this.form.series_id) {
                return this.$message.warning('El establecimiento no tiene series disponibles para el comprobante');
            }
        },
        async clickCancel() {

            this.loading_submit = true
            await this.sleep(800);
            this.loading_submit = false
            this.cleanLocalStoragePayment()
            this.$eventHub.$emit('cancelSale')

        },
        cleanLocalStoragePayment() {

            this.setLocalStoragePayment('amount', null)
            this.setLocalStoragePayment('enter_amount', null)
            this.setLocalStoragePayment('difference', null)
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async asignPlateNumberToItems() {
            if (this.form.plate_number) {

                await this.form.items.forEach(item => {

                    let at = _.find(item.attributes, {'attribute_type_id': '5010'})

                    if (!at) {
                        item.attributes.push({
                            attribute_type_id: '7000',
                            description: "Gastos Art. 37 Renta:  Número de Placa",
                            value: this.form.plate_number,
                            start_date: null,
                            end_date: null,
                            duration: null,
                        })
                    }
                });
            }
        },
        getDiscountPercentages()
        {
            if (!this.is_discount_amount) {
                return Number(this.discount_amount) || 0
            }

            const globalDiscount = (this.form.discounts || []).find(discount =>
                ['02', '03'].includes(
                    this.normalizeDiscountTypeId(discount.discount_type_id)
                )
            )

            return globalDiscount
                ? _.round(Number(globalDiscount.factor) * 100, 2)
                : 0
        },
        tokenValidated()
        {
            this.form.token_validated_for_discount = true
        },
        validateRestrictSellerDiscount()
        {
            if(this.configuration.restrict_seller_discount && this.typeUser !== 'admin')
            {
                const all_percentages = this.getDiscountPercentages()

                if(all_percentages > parseFloat(this.configuration.sellers_discount_limit) && !this.form.token_validated_for_discount)
                {
                    this.totalDiscountPercentage = _.round(all_percentages, 2)
                    this.showDialogDiscountPermission = true

                    return {
                        success: false,
                    }
                }
            }

            return {
                success: true
            }
        },
        validateRestrictSaleItemsCpe()
        {
            if(this.applyRestrictSaleItemsCpe)
            {
                let errors_restricted = 0

                this.form.items.forEach(row => {
                    if(this.isRestrictedForSale(row.item)) errors_restricted++
                })

                if(errors_restricted > 0) return this.getObjectResponse(false, 'No puede generar el comprobante, tiene productos restringidos.')
            }


            return this.getObjectResponse()
        },
        getObjectResponse(success = true, message = null)
        {
            return {
                success: success,
                message: message,
            }
        },
        async clickPayment()
        {
            this.loading_submit = true

            if (!this.all_series.length) {
                this.loading_submit = false
                return this.$message.warning('Cargando series, intente nuevamente')
            }

            const selectedSeries = _.find(this.all_series, {id: this.form.series_id})
            
            if (!selectedSeries || selectedSeries.document_type_id !== this.form.document_type_id) {
                this.loading_submit = false
                this.filterSeries()
                return this.$message.warning('La serie no corresponde al tipo de comprobante, verifique e intente nuevamente')
            }

            // validacion restriccion de productos
            const validate_restrict_sale_items_cpe = this.validateRestrictSaleItemsCpe()
            if(!validate_restrict_sale_items_cpe.success) {
                this.loading_submit = false
                return this.$message.error(validate_restrict_sale_items_cpe.message)
            }

            // validacion restriccion de descuento
            const validate_restrict_seller_discount = this.validateRestrictSellerDiscount()
            if(!validate_restrict_seller_discount.success) {
                this.loading_submit = false
                return
            }

            if (this.form.payments == 0 ) {
                this.form.payment_condition_id = "02";
            }

            // validacion sistema por puntos
            if(this.enabledPointSystem)
            {
                const validate_exchange_points = this.validateExchangePoints()
                if(!validate_exchange_points.success) {
                    this.loading_submit = false
                    return this.$message.error(validate_exchange_points.message)
                }
            }
            else
            {
                if(this.form.total <= 0) {
                    this.loading_submit = false
                    return this.$message.error('El total debe ser mayor a 0')
                }
            }


            if (!moment(moment().format("YYYY-MM-DD")).isSame(this.form.date_of_issue)) {
                this.loading_submit = false
                return this.$message.error('La fecha de emisión no coincide con la del día actual');
            }

            if (!this.form.series_id) {
                this.loading_submit = false
                return this.$message.warning('El establecimiento no tiene series disponibles para el comprobante');
            }

            if (this.form.document_type_id === "80") {
                this.form.prefix = "NV";
                this.form.paid = 1;
                this.resource_documents = "sale-notes";
                this.resource_payments = "sale_note_payments";
                this.resource_options = this.resource_documents;
            } else {
                this.form.prefix = null;
                this.resource_documents = "documents";
                this.resource_payments = "document_payments";
                this.resource_options = this.resource_documents;
                await this.asignPlateNumberToItems()
            }

            // this.loading_submit = true
            this.locked_submit = true

            this.form.dcto_monto_input = Number(this.discount_amount) || 0
            // this.form.dcto_totales_input = this.discount_amount // asignado en totalDiscountOnlyVisual()
            this.form.monto_pagar_sin_dcto = this.monto_pagar_sin_dcto
            this.form.global_discount_as_percentage = !this.is_discount_amount

            const payment_method_type_id_local_storage = this.form.payments.length ? this.form.payments[0].payment_method_type_id : null
            this.form.payment_method_type_id = this.payment_method_type_id || payment_method_type_id_local_storage
            this.verifyPaymentCondition()
            // return

            await this.$http.post(`/${this.resource_documents}`, this.form).then(response => {
                if (response.data.success) {

                    if (this.form.document_type_id === "80") {

                        // this.form_payment.sale_note_id = response.data.data.id;
                        this.form_cash_document.sale_note_id = response.data.data.id;

                    } else {

                        // this.form_payment.document_id = response.data.data.id;
                        this.form_cash_document.document_id = response.data.data.id;
                        this.statusDocument = response.data.data.response
                        
                    }

                    this.form_cash_document.cash_id = response.data.data.cash_id;

                    this.documentNewId = response.data.data.id;

                    // this.showDialogOptions = true;
                    this.showOptionsDialog(response)

                    // this.savePaymentMethod();
                    // this.saveCashDocument();

                    // this.initFormPayment() ;
                    this.cleanLocalStoragePayment()
                    if(this.isPrint){
                        this.gethtml();
                    }
                    this.$eventHub.$emit('saleSuccess');
                } else {
                    this.$message.error(response.data.message);
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data;
                } else {
                    this.$message.error(error.response.data.message);
                }
            }).then(() => {
                this.loading_submit = false;
                this.locked_submit = false
            });
        },

        showOptionsDialog(response){

            if(this.hidePdfViewDocuments)
            {
                const response_data = response.data.data

                if(this.form.document_type_id === '80')
                {
                    this.$message.success(`Nota de venta registrada: ${response_data.number_full}`)
                }
                else
                {
                    if(response_data.response.sent)
                    {
                        this.$message.success(response_data.response.description)
                    }
                    else
                    {
                        this.$message.success(`Comprobante registrado: ${response_data.number_full}`)
                    }
                }

                this.clickCancel()
            }
            else
            {
                this.showDialogOptions = true
            }

        },

        gethtml(){
            this.form.datahtml="";
            var doc='salenote';
            var route = `/printticket/document/${this.documentNewId}/ticket`;
            if(this.resource_documents!=='documents'){
                route = `/sale-notes/ticket/${this.documentNewId}/ticket`;
            }

            // console.log(route);

            this.$http.get(route)
            .then(response => {
                if (response.data.length>0) {
                    this.form.datahtml=response.data;
                    this.printticket();
                }

            })
            .catch(error => {
                console.log(error);
            })
        },
        async printticket(){
            //getUpdatedConfig();
            await this.sleep(400);
            var configg = getUpdatedConfig();
            var opts = getUpdatedConfig();
            var printData = [
                {
                    type: 'html',
                    format: 'plain',
                    data: this.form.datahtml,
                    options: opts
                }
            ];
            // qz.print(configg, printData).catch(displayError);

            qz.print(configg, printData)
                .then(()=>{

                    this.$notify({
                        title: '',
                        message: 'Impresión en proceso...',
                        type: 'success'
                    })

                })
                .catch(displayError)
        },
        saveCashDocument() {
            this.$http.post(`/cash/cash_document`, this.form_cash_document)
                .then(response => {
                    if (response.data.success) {
                        // console.log(response)
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
        },
        savePaymentMethod() {
            this.$http.post(`/${this.resource_payments}`, this.form_payment)
                .then(response => {
                    if (response.data.success) {
                        // console.log(response)
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.records[index].errors = error.response.data;
                    } else {
                        console.log(error);
                    }
                })
        },
        getTables() {
            return this.$http.get(`/${this.resource}/payment_tables`)
                .then(response => {
                    this.all_series = response.data.series
                    this.payment_method_types = response.data.payment_method_types
                    this.cards_brand = response.data.cards_brand
                    this.global_discount_types = response.data.global_discount_types
                    this.enabled_discount_global = response.data.enabled_discount_global
                    this.filterSeries()
                    this.setConfigGlobalDiscountType()
                })

        },

        verifyPaymentCondition() {
            if(this.payment_method_types.length) {
                const payment = this.payment_method_types.find(item => item.id === this.form.payment_method_type_id)
                if (payment.is_credit) {
                    this.form.payment_condition_id = '02'
                } else {
                    this.form.payment_condition_id = '01'
                }
            }
        },
        getItemsTotalDiscount() {
            return _.round(
                this.form.items.reduce(
                    (sum, row) => sum + (Number(row.total_discount) || 0),
                    0
                ),
                2
            )
        },

        normalizeDiscountTypeId(value) {
            return String(value || '').trim().padStart(2, '0')
        },
        setMixedGlobalDiscount(inputDiscount, taxedBase, nonTaxedBase) {
            const round2 = value => _.round(value, 2)

            const originalValue = Number(this.form.total_value) || 0
            const originalIgv = Number(this.form.total_igv) || 0
            const originalTaxes = Number(this.form.total_taxes) || 0
            const originalSubtotal = Number(this.form.subtotal) || 0
            const originalTotal = Number(this.form.total) || 0

            // Importe gravado incluido el impuesto.
            const taxedGross = round2(taxedBase + originalIgv)
            const eligibleGross = round2(taxedGross + nonTaxedBase)

            const factorRaw = this.is_discount_amount
                ? inputDiscount / eligibleGross
                : inputDiscount / 100

            if (factorRaw <= 0 || factorRaw >= 1) {
                this.$message.error('El descuento debe ser menor al total elegible')
                return
            }

            const targetDiscount = this.is_discount_amount
                ? round2(inputDiscount)
                : round2(eligibleGross * factorRaw)

            const itemDiscounts = round2(
                this.form.items.reduce(
                    (sum, row) => sum + (Number(row.total_discount) || 0),
                    0
                )
            )

            if (this.globalDiscountTypeId === '02') {
                const taxedDiscount = round2(taxedBase * factorRaw)
                const newTaxedBase = round2(taxedBase - taxedDiscount)
                const newIgv = round2(originalIgv * (1 - factorRaw))

                const newTaxes = round2(
                    originalTaxes - originalIgv + newIgv
                )

                // Reducción económica: descuento de base + reducción del impuesto.
                const taxedGrossReduction = round2(
                    taxedDiscount + originalIgv - newIgv
                )

                // Se asigna aquí cualquier residuo de centavos, acotado a [0, base no gravada].
                const nonTaxedTarget = round2(targetDiscount - taxedGrossReduction)
                const nonTaxedDiscount = Math.max(
                    0,
                    Math.min(nonTaxedTarget, round2(nonTaxedBase))
                )

                // Diferencia que no cupo en la porción no gravada.
                const residual = round2(nonTaxedTarget - nonTaxedDiscount)

                if (Math.abs(residual) > 0.01) {
                    this.$message.warning(
                        `El descuento aplicado es ${round2(targetDiscount - residual)} por ajuste de redondeo`
                    )
                }


                this.form.total_taxed = newTaxedBase
                this.form.total_igv = newIgv
                this.form.total_taxes = newTaxes
                this.form.total_value = round2(originalValue - taxedDiscount)
                this.form.subtotal = round2(
                    originalSubtotal - taxedGrossReduction
                )
                this.form.total = round2(
                    originalTotal - taxedGrossReduction - nonTaxedDiscount
                )

                this.form.total_discount = round2(
                    itemDiscounts + taxedDiscount + nonTaxedDiscount
                )

                if (taxedDiscount > 0) {
                    this.setGlobalDiscount(
                        _.round(taxedDiscount / taxedBase, 5),
                        taxedDiscount,
                        round2(taxedBase).toFixed(2),
                        '02'
                    )
                }

                if (nonTaxedDiscount > 0) {
                    this.setGlobalDiscount(
                        _.round(nonTaxedDiscount / nonTaxedBase, 5),
                        nonTaxedDiscount,
                        round2(nonTaxedBase).toFixed(2),
                        '03'
                    )
                }


                return
            }

                        // Configuración 03: no modifica base ni impuesto.
            const taxedDiscount = round2(taxedGross * factorRaw)
            const nonTaxedTarget = round2(targetDiscount - taxedDiscount)
            const nonTaxedDiscount = Math.max(
                0,
                Math.min(nonTaxedTarget, round2(nonTaxedBase))
            )

            this.form.subtotal = originalSubtotal
            this.form.total = round2(
                originalTotal - taxedDiscount - nonTaxedDiscount
            )
            this.form.total_discount = round2(
                itemDiscounts + taxedDiscount + nonTaxedDiscount
            )

            if (taxedDiscount > 0) {
                this.setGlobalDiscount(
                    _.round(taxedDiscount / taxedGross, 5),
                    taxedDiscount,
                    taxedGross.toFixed(2),
                    '03'
                )
            }

            if (nonTaxedDiscount > 0) {
                this.setGlobalDiscount(
                    _.round(nonTaxedDiscount / nonTaxedBase, 5),
                    nonTaxedDiscount,
                    nonTaxedBase.toFixed(2),
                    '03'
                )
            }

        },
        sumDiscountsNoBaseByItem(row) {
            let sum_discount_no_base = 0

            if (row.discounts) {
                sum_discount_no_base = _.sumBy(row.discounts, (discount) => {
                    return (this.normalizeDiscountTypeId(discount.discount_type_id) === '01')
                        ? Number(discount.amount) || 0
                        : 0
                })
            }

            return sum_discount_no_base
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/pos/partials/payment.vue